/**
 * @name formatDateRange
 * @description 시작일과 종료일을 포맷팅
 */
export function formatDateRange(startAt: string, endAt: string): string {
  const start = new Date(startAt);
  const end = new Date(endAt);

  const startMonth = start.getMonth() + 1;
  const startDay = start.getDate();
  const startDayOfWeek = getDayOfWeek(start);

  const endMonth = end.getMonth() + 1;
  const endDay = end.getDate();
  const endDayOfWeek = getDayOfWeek(end);
  return `${startMonth}월 ${startDay}일(${startDayOfWeek}) ~ ${endMonth}월 ${endDay}일(${endDayOfWeek})`;
}

/**
 * @name formatDateRangeShort
 * @description 시작일과 종료일을 "01. 24(월) ~ 01. 26(수)" 형식으로 포맷팅
 */
export function formatDateRangeShort(startAt: string, endAt: string): string {
  const start = new Date(startAt);
  const end = new Date(endAt);

  const startMonth = String(start.getMonth() + 1).padStart(2, '0');
  const startDay = String(start.getDate()).padStart(2, '0');
  const startDayOfWeek = getDayOfWeek(start);

  const endMonth = String(end.getMonth() + 1).padStart(2, '0');
  const endDay = String(end.getDate()).padStart(2, '0');
  const endDayOfWeek = getDayOfWeek(end);

  return `${startMonth}. ${startDay}(${startDayOfWeek}) ~ ${endMonth}. ${endDay}(${endDayOfWeek})`;
}

/**
 * @name formatSingleDate
 * @description 단일 날짜를 "2024. 01. 24(월)" 형식으로 포맷팅
 */
export function formatSingleDate(
  date: string | Date | null | undefined
): string {
  if (!date) return '미정';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const dayOfWeek = getDayOfWeek(d);
  return `${year}. ${month}. ${day}(${dayOfWeek})`;
}

/**
 * @name getDayOfWeek
 * @description 요일을 한글로 반환
 */
export function getDayOfWeek(date: Date): string {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return days[date.getDay()];
}

/**
 * 시간 포맷팅
 */
export function formatTime(date: Date): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

/**
 * 날짜 문자열을 Date 객체로 변환
 */
export function toDate(dateString: string | Date): Date {
  return new Date(dateString);
}
